// extracted by mini-css-extract-plugin
module.exports = {"form":"PopUpForm_form__J8-sZ","actions":"PopUpForm_actions__3RAt0"};